import "core-js/modules/es.array.slice.js";
import React from 'react';
import { useTranslation } from 'react-i18next';
import Box from 'components/Box';
import Button from 'components/Button';
import EmptyStateController from 'components/EmptyStateController';
import StatsList from 'components/StatsList';
import StatsWrapper from './StatsWrapper';
function InlineStatsPanel(_ref) {
  var isLoading = _ref.isLoading,
    isError = _ref.isError,
    _ref$isPanelLayout = _ref.isPanelLayout,
    isPanelLayout = _ref$isPanelLayout === void 0 ? false : _ref$isPanelLayout,
    title = _ref.title,
    _ref$data = _ref.data,
    data = _ref$data === void 0 ? [] : _ref$data,
    handleViewAll = _ref.handleViewAll,
    onClick = _ref.onClick;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var actions;
  if (data.length) {
    actions = /*#__PURE__*/React.createElement(Button, {
      size: isPanelLayout ? 'small' : 'medium',
      variant: isPanelLayout ? 'transparent' : 'default',
      iconRight: isPanelLayout ? 'hierarchy' : undefined,
      onClick: onClick
    }, t('actions_view_all'));
  }
  return /*#__PURE__*/React.createElement(StatsWrapper, {
    actions: actions,
    title: title,
    isPanelLayout: isPanelLayout
  }, /*#__PURE__*/React.createElement(EmptyStateController, {
    isLoading: isLoading,
    isEmpty: !data.length,
    isError: isError
  }, /*#__PURE__*/React.createElement(StatsList, {
    data: data.slice(0, 5)
  })), handleViewAll && /*#__PURE__*/React.createElement(Box, {
    textAlign: "center",
    mb: -12
  }, /*#__PURE__*/React.createElement(Button, {
    size: "medium",
    variant: "transparent",
    onClick: handleViewAll
  }, t('actions_view_all'))));
}
export default InlineStatsPanel;
export { default as StatsWrapper } from './StatsWrapper';
export { default as AssetPopularUsersStats } from './AssetPopularUsersStats';
export { default as AssetActivityLog } from './AssetActivityLog';
export { default as PopularAssetInFolderOrPlaylistStats } from './PopularAssetInFolderOrPlaylistStats';
export { default as PlaylistRecentUsersStats } from './PlaylistRecentUsersStats';